import {useForm} from "react-hook-form";

import { Link } from "react-router-dom";
import { createPortal } from 'react-dom';
import Cookies from "js-cookie";

import { useContext, createContext } from "react";

import Logo from "../../assets/images/company_logo_svg.svg";
import IconEye from "../../assets/images/eye.svg";
import IconEyeSlash from "../../assets/images/eye-slash.svg";

import { useEffect, useState } from "react";
import { getRootUrl, getBkendUrl, getJsonPath } from "../../consts.js";

import axios_with_token from "../../axios_with_token.js";

async function doWWappLogin(data){
    const bkendUrl = getBkendUrl();
    const jsonPath = getJsonPath();
    const wwappLoginUrl = `${bkendUrl}/jwt/wwapp/login/${jsonPath}`;
    
    return axios_with_token(wwappLoginUrl, {
        method: "post",
        data: data,
        withCredentials: true,
        headers: { 
            "Content-Type": "multipart/form-data",
            // "Content-Type": "application/x-www-form-urlencoded",
            "Access-Control-Allow-Credentials": "true",
            // "Access-Control-Allow-Origin": bkendUrl,    
            // "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, PATCH, DELETE",    
            // "Access-Control-Allow-Headers": "X-Requested-With,content-type",
            "Cache-Control": "no-cache",
            // "Content-Type": "application/x-www-form-urlencoded",
            // withCredentials: true
            // Cookie: ['x-auth-token-'+jsonPath, Cookies.get('x-auth-token-'+jsonPath)].join('='),
        }
    }).then(res=>{
        if(!res){
            throw('login res null.');
        }

        console.log('login res :', res);
        if(res.data.status && res.data.status === "success"){
            // console.log('[set login info]', getTokenName(), res.data.token, 'userInfo', JSON.stringify(res.data));
            // Cookies.set(getTokenName(), res.data.token);
            Cookies.set('wwapp_loggedIn', true);
            Cookies.set('wwapp_userInfo', JSON.stringify(res.data.user_info));

            // setLoggedin(true);
            // setUserInfo(res.data.user_info);

            return {
                loggedin: true,
                userInfo: res.data.user_info
            };
        }else{
            throw("username or passwrod error.")
        }
    });

}

const loginContext = createContext();
export function useLoginContext(){
    return useContext(loginContext);
}

export default function LoginProvider({children, username, password}){
    const [loggedin, setLoggedin] = useState(prev=>{
        let l = false;
        try {
            l = JSON.parse(Cookies.get('wwapp_loggedIn'));
        }catch(err){
            l = false;
        }

        return l;
    });
    const [userInfo, setUserInfo] = useState(prev=>{
        let l = {};
        try {
            l = JSON.parse(Cookies.get('wwapp_userInfo'));
        }catch(err){

        }

        return l;
    });

    const rootUrl = getRootUrl();

    function logout(){
        Cookies.set('wwapp_loggedIn', JSON.stringify(false));
        Cookies.set('wwapp_userInfo', JSON.stringify({}));
        setLoggedin(false);
    }

    function Login({setLoggedin, setUserInfo}){
        const {register, handleSubmit, formState:{errors}} = useForm();
        const [error, setError] = useState(false);

        const onSubmit = async data=>{
            return doWWappLogin(data).then(data=>{
                setLoggedin(true);
                setUserInfo(data.userInfo);
            }).catch(err=>{
                setError(err);
            })
        };

        // show/hide password icon
        const [pwdType, setPwdType] = useState('password');
        const handleTglPwd = () => {
            if (pwdType==='password'){
                setIcon("hide");
                setPwdType('text')
            } else {
                setIcon("show")
                setPwdType('password')
            }
        }

        const [icon, setIcon] = useState("show");

        return loggedin?'':createPortal(<main className='login' style={{"zIndex":"9999999999"}}>
                <div className="modal show" tabIndex="-1">
                    <div className="modal-dialog modal-fullscreen-sm-down">
                        <div className="modal-content container shadow-lg">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="modal-header">
                                    <img src={Logo} />
                                    <h3 className="modal-title" >Online Order Log In</h3>
                                    {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
                                </div>
                                <div className="modal-body col-md-10 offset-md-1">
                                        <div className="mb-3">
                                            <label htmlFor="username" className="form-label">User name</label>
                                            <input type="text" id="username" name="username" className="form-control" {...register("username", {required: true})} />
                                            {errors.username && <p className="fld-error">This field is required</p>}
                                            {/* <label htmlFor="exampleInputEmail1" className="form-label">Email address</label> */}
                                            {/* <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" /> */}
                                            {/* <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div> */}
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="password" className="form-label">Password</label>
                                            <div className="input-group">
                                                <input type={pwdType} className="form-control" id="password" name="password" {...register("password", {required:true})} />
                                                <span className="input-group-text align-middle" onClick={handleTglPwd}>
                                                    <img src={icon==="show"?IconEye:IconEyeSlash} className="align-middle pe-none p-0 m-0" style={{"width": "1.5em"}} />
                                                </span>                                            
                                            </div>

                                            {errors.password && <p className="fld-error">This field is required</p>}
                                        </div>
                                        {/* <div className="mb-3 form-check">
                                            <input type="checkbox" className="form-check-input" id="checkMeOut" name="checkMeOut" />
                                            <label className="form-check-label" htmlFor="checkMeOut">Check me out</label>
                                        </div> */}
                                        {error&&<div className="text-danger">{(error||{}).message||'unkown error'}</div>}
                                </div>
                                <div className="">
                                    <div
                                        className="col d-flex justify-content-end m-3"
                                    >
                                            {/* <button type="button" className="btn btn-primary"
                                                onClick={evt=>setShowUrlSettings(!showUrlSettings)}
                                            >toggle url settings</button> */}
                                            <button type="submit" className="btn btn-primary">Submit</button>
                                        {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                        <button type="button" className="btn btn-primary">Save changes</button> */}

                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <div className="">
                                        <p>No account yet? <Link
                                            to={`${rootUrl}/wwapp/register`}
                                        ><strong>Get one here</strong></Link>.</p>
                                    </div>  
                                </div>
                            </form>                 
                        </div>
                    </div>
                </div>
            </main>,
            document.getElementById('dialog-root')
        );
    };

    // [] persist log in data
    useEffect(_=>{
        Cookies.set('wwapp_loggedIn', loggedin)
    }, [loggedin])

    useEffect(_=>{
        Cookies.set('wwapp_userInfo', JSON.stringify(userInfo));
    }, [userInfo])

    if(username && !loggedin){
        return <div>logging in ...</div>;
    }

    return <loginContext.Provider
        value={{
            loggedin,
            setLoggedin,
            logout,
            userInfo
        }}
    >
        {!loggedin&&<Login
            setLoggedin = {setLoggedin}
            setUserInfo= {setUserInfo}
        ></Login>}
        {loggedin&&children}
    </loginContext.Provider>;
}
